module.exports = "/work-site/img/overview.e0b4164d.png";